import { render, staticRenderFns } from "./AdditionalServicesExpensesFormDialog.vue?vue&type=template&id=8f2a672c&scoped=true&lang=pug&"
import script from "./AdditionalServicesExpensesFormDialog.vue?vue&type=script&lang=ts&"
export * from "./AdditionalServicesExpensesFormDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AdditionalServicesExpensesFormDialog.vue?vue&type=style&index=0&id=8f2a672c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2a672c",
  null
  
)

export default component.exports